import { routes as home } from '@/modules/core/home'
import { routes as auth } from '@/modules/core/auth'
export default [...home, ...auth]
